export * from "./shared";

/**
 * ⚠️ DIVERGENT — web has a FOURTH key, `close_switch_user`, which mobile's copy lacks.
 * `CashRegisterSlice`'s `saveCashSettlementDetails` branches on it on web only, so the two
 * copies are kept apart rather than unified. Core importers must deep-import this variant
 * (`../../utils/constants/index.desktop`) — a bare folder import would type against
 * `index.native` (ledger hazard 16).
 *
 * Verbatim from `apps/web/src/utils/constants.js`.
 */
export const CASH_REGISTER_MODAL_TYPES = {
  opening_balance: "opening_balance",
  closing_balance: "closing_balance",
  close_switch_branch: "close_switch_branch",
  close_switch_user: "close_switch_user",
};

/**
 * ⚠️ DIVERGENT — web has 30 keys, mobile 14. Mobile's copy is NOT a subset: it adds `drkLabel`
 * and `iframeScreenPageId`, while web adds 18 the mobile app has no concept of (support-login,
 * health service, cart audit, app-update, fcm...). Core importers must name the variant
 * (ledger hazard 16). Verbatim from `apps/web/src/utils/constants.js`.
 */
export const LOCALSTORAGE_KEYS = {
  aToken: "ATOKEN",
  deviceIdentifier: "deviceIdentifier",
  businessInfoData: "businessInfoData",
  branchName: "",
  businessName: "",
  isShowOfflineModeToggle: "isShowOfflineModeToggle",
  isOffline: "isOffline",
  isSupportLogin: 'isSupportLogin',
  supportIdToken: "supportIdToken",
  supportSign: "supportSign",
  blePrinterList: "blePrinterList",
  usbPrinter : "usbPrinter",
  // Same string the Sencha POS writes (`WeighingScaleController.saveUSBWeighingScale`), kept
  // deliberately so the two apps name one concept the same way. NOT an automatic migration:
  // under the NW.js shell the React app is a cross-origin iframe with its own storage, so a
  // scale configured in Sencha must still be re-selected here.
  usbWeighingScale: "usbWeighingScale",
  defaultPrinter: "defaultPrinter",
  adhocTables: "adhoc-tables",
  printBillFromMaster: "printBillFromMaster",
  webviewProps: "webviewProps",
  nwAppVersion: "nwAppVersion",
  nwPlatform: "nwPlatform",
  appUpdateAvailable: "appUpdateAvailable",
  testingKey: 'testingKey',
  recommendedItems: 'recommendedItems',
  APP_VERSION: "APP_VERSION",
  PREVIOUS_SALE_DATA: "PREVIOUS_SALE_DATA",
  notificationsPolling: "notificationsPolling",
  fcmToken: "fcmToken",
  USER_DATA: "userData",
  HEALTH_SERVICE_STATUS: "healthServiceStatus",
  RECENT_USER:"recentUsers",
  CART_AUDIT_SESSION: 'cart_audit_session',
};

/**
 * The local-store domains this platform reads and writes.
 *
 * ⚠️ **WEB-ONLY — verified with `grep`, not assumed:** `apps/mobile/src/utils/constants.js` has
 * no `OFFLINE_DOMAINS`. Mobile passes its domain strings as literals at each call site.
 *
 * Uplifted for `helpers/cartAuditHelper`, which writes audit rows under `CART_AUDIT`.
 */
export const OFFLINE_DOMAINS = {
  CART_AUDIT: 'CART_AUDIT',
  CUSTOMER: 'CUSTOMER',
  FEEDBACK: 'FEEDBACK',
  ITEM: 'ITEM',
  OPTIONSET: 'OPTIONSET',
  OTHERS: 'OTHERS',
  PREORDER: 'PREORDER',
  SALE: 'SALE',
}

/**
 * Backend error code for an order the KDS has not processed yet.
 *
 * ⚠️ **WEB-ONLY — verified with a repo-wide grep**: the string does not appear anywhere in
 * `apps/mobile`. Its two consumers are both on this platform.
 */
export const REST_ORDER_IS_NOT_PROCESSED_ON_KDS = "REST_ORDER_IS_NOT_PROCESSED_ON_KDS";
